import { watch } from "vue";
import { useClientContextStore } from "../../store/eplex/eplexClientContext";

/**
 * Наблюдение за сменой личности под уже открытой вкладкой (CAB-696, CAB-734).
 *
 * Сессия кабинета живёт в куке домена `.eplex.ru` — общей для всех вкладок и
 * стендов. Вход другой учёткой рядом, выход из демо-доступа, правка на стороне
 * LH — и страница, смонтированная до этого, продолжает показывать данные
 * прежнего человека: второй раз она не монтируется никогда. Поэтому всё, что
 * привязано к личности, перечитывается по одному общему признаку, а не каждым
 * экраном по-своему.
 *
 * Обработчик зовётся только на СМЕНЕ: первая загрузка кабинета — не смена, там
 * данные читаются обычным путём, на монтировании.
 */
export function useIdentityChange(onChange: (identity: string) => void): void {
  const clientContext = useClientContextStore();

  // Помним последнюю известную личность сами, а не через prev в watch: контекст
  // умеет ненадолго уходить в error (недоступен бэкенд), и prev в этот момент —
  // null, из-за чего настоящая смена после восстановления выглядела бы как
  // первая загрузка
  let lastIdentity: string | null = null;

  watch(
    () => clientContext.identityKey,
    (next) => {
      if (!next) return;

      const previous = lastIdentity;
      lastIdentity = next;

      if (previous === null || previous === next) return;

      onChange(next);
    },
    { immediate: true },
  );
}
